'use strict';

var requirePromise = require('./requirePromise');

var implementation = require('./implementation');

module.exports = function getPolyfill() {
	requirePromise();
	return typeof Promise.prototype['finally'] === 'function' ? Promise.prototype['finally'] : implementation;
};



//////////////////
// WEBPACK FOOTER
// ./~/promise.prototype.finally/polyfill.js
// module id = 380
// module chunks = 35783957827783 172322841747965